import React, { useEffect, useState } from "react";
import { Wrapper } from "./Style/Wrapper";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import Pagination from "../../../assets/SharedComponents/Pagination";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import { FaFilterIcon } from "../../../assets/Images/icon";
import StaticFilter from "../../../assets/SharedComponents/Filters/StaticFilter";
import RecordCount from "../../../assets/SharedComponents/RecordCount/RecordCount";
import ExtractReport from "../../../assets/SharedComponents/ExtractReport/ExtractReport";
import API from "../../../api/axios";
import {
  APIError,
  downloadFileError,
  formatCurrency,
  showUserTypeBadge,
} from "../../../core/utils";
import { APP_URLS } from "../../../api/url";
import moment from "moment";
import {
  DEPOSITHISTORYSTATUS,
  DEPOSITHISTORYSTATUSINVERSE,
} from "../../../config/constant";
import download from "downloadjs";
import SearchKey from "../../../assets/SharedComponents/Search/SearchKey";
import faHide from "../../../assets/Images/icons/svgIcon/FaHide.svg";
import Sorting from "../../../assets/SharedComponents/Sorting/Sorting";
import { confirmAlert } from "react-confirm-alert";
import FilterDrawer from "./Components/Filters/FilterDrawer";
import RejectRequest from "./Components/rejectRequest";

const depositHistoryStatus = Object.keys(DEPOSITHISTORYSTATUS).map((key) => ({
  name: DEPOSITHISTORYSTATUS[key],
  value: key,
}));

const AuctionDepositHistory = () => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [depositsHistory, setDepositsHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [sort, _sort] = useState("-refund_requested_on");
  const [filters, setFilters] = useState({
    status: "",
    countValue: "",
    reference: "",
    userId: "",
    subId: "",
    refundRequestedOnFrom: "",
    refundRequestedOnTo: "",
    refundApprovedOnFrom: "",
    refundApprovedOnTo: "",
    refundSentOnFrom: "",
    refundSentOnTo: "",
  });

  const [isFilterApplied, _isFilterApplied] = useState(false);
  const [showFiltersDrawer, _showFiltersDrawer] = useState(true);

  const [isSaving, _isSaving] = useState(false);

  useEffect(() => {
    fetchDepositHistory();
  }, [filters, page, sort]);

  const fetchDepositHistory = () => {
    setIsLoading(true);
    API.get(`${APP_URLS.LIST_DEPOSIT}${getFilters()}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success) {
          setDepositsHistory(resp.data.deposit.data);
          setTotalPage(resp.data.deposit.last_page);
          setTotal(resp.data.deposit.total);
        } else {
          toast.error(resp.message);
        }
      })
      .catch((error) => {
        toast.error(APIError(error).message);
      })
      .finally(() => setIsLoading(false));
  };

  const handleExtractReport = () => {
    API.get(`${APP_URLS.LIST_DEPOSIT}/download_excel_file${getFilters()}`, {
      responseType: "blob",
    })
      .then((res) => {
        const resp = res.data;
        if (resp !== null) {
          toast.success("Downloading. Please wait", {
            position: toast.POSITION.TOP_RIGHT,
          });
          const content = res.headers["content-type"];
          const currentDate = moment().format("YYYY-MM-DD HH-mm-ss");
          const fileName = `${currentDate}_auction_deposit_history_report.xlsx`;
          download(resp, fileName, content);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(async function (error) {
        let error_message = await downloadFileError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  function getFilters() {
    const params = new URLSearchParams();

    if (page) params.append("page", page);
    if (filters.countValue)
      params.append("per_page", filters.countValue.toString());
    if (sort) params.append("sort", sort);

    const filterParams = {
      status: filters.status,
      transfer_reference: filters.reference,
      user_id: filters.userId,
      subsidiary_id: filters.subId,
      refund_requested_from: filters.refundRequestedOnFrom,
      refund_requested_to: filters.refundRequestedOnTo,
      refund_approved_from: filters.refundApprovedOnFrom,
      refund_approved_to: filters.refundApprovedOnTo,
      refund_sent_from: filters.refundSentOnFrom,
      refund_sent_to: filters.refundSentOnTo,
    };

    Object.entries(filterParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(`filter[${key}]`, value);
      }
    });

    return `?${params.toString()}`;
  }

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setTotalPage(0);
    setPage(1);
  };

  const handleSort = (sortType) => {
    _sort(sortType);
    setPage(1);
    setTotalPage(0);
  };

  const clearFilter = () => {
    _isFilterApplied(true);
    if (Object.values(filters).some(Boolean)) {
      setFilters({
        status: "",
        countValue: 10,
        reference: "",
        userId: "",
        subId: "",
        refundRequestedOnFrom: "",
        refundRequestedOnTo: "",
        refundApprovedOnFrom: "",
        refundApprovedOnTo: "",
        refundSentOnFrom: "",
        refundSentOnTo: "",
      });
      setTotalPage(0);
      setPage(1);
    }
  };

  const handleAccept = (id) => {
    if (isSaving) return;
    confirmAlert({
      title: "Confirm to accept",
      message: "Are you sure you want to accept this request?",
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            _isSaving(true);
            API.post(
              `${APP_URLS.LIST_DEPOSIT}/${id}${APP_URLS.UPDATE_REQUEST}`,
              {
                status: DEPOSITHISTORYSTATUSINVERSE.REFUND_APPROVED_MANUALLY,
              }
            )
              .then((res) => {
                _isSaving(false);
                const resp = res.data;
                if (resp.success) {
                  toast.success("Request has been accepted successfully.", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                  fetchDepositHistory();
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch((error) => {
                _isSaving(false);
                toast.error(APIError(error), {
                  position: toast.POSITION.TOP_RIGHT,
                });
              });
          },
        },
        { label: "No" },
      ],
    });
  };

  const showActionButton = (status, id) => {
    if (status == DEPOSITHISTORYSTATUSINVERSE.REFUND_REQUESTED) {
      return (
        <div className="actionButtons">
          <button
            className="accept"
            onClick={() => handleAccept(id)}
            disabled={isSaving}
          >
            Accept
          </button>
          <RejectRequest
            historyId={id}
            isSaving={isSaving}
            _isSaving={_isSaving}
            fetchDepositHistory={fetchDepositHistory}
          />
        </div>
      );
    }
    return "-";
  };

  return (
    <Wrapper>
      <div className="auctionMainContainer">
        <div className="row mt-4 position-relative">
          <img
            src={faHide}
            alt="filters"
            className={(showFiltersDrawer ? "open" : "close") + " filterbtn"}
            onClick={() => _showFiltersDrawer(!showFiltersDrawer)}
          />
          <div
            className={
              (showFiltersDrawer === true ? "show" : "hide") +
              " col-md-3 col-lg-2"
            }
          >
            <FilterDrawer
              handleChange={handleChange}
              filters={filters}
              isFilterApplied={isFilterApplied}
              _isFilterApplied={_isFilterApplied}
            />
          </div>
          <div
            className={
              showFiltersDrawer === true
                ? "col-md-9 col-lg-10"
                : "col-md-12 col-lg-12"
            }
          >
            <div className="row mt-4">
              <div className="col-md-12 mb-2">
                <h1>AUCTION DEPOSIT HISTORY</h1>
              </div>
            </div>

            <div className="d-flex align-items-center flex-wrap justify-content-end mb-2 gap-2 info-wrap">
              <StaticFilter
                placeholder="Status"
                data={depositHistoryStatus}
                value={filters.status}
                handleChange={(e) => handleChange("status", e.target.value)}
              />
              <SearchKey
                onSearchClick={(search) => handleChange("reference", search)}
                id="searchData"
                filters={isFilterApplied}
                val={filters.reference}
                _filters={_isFilterApplied}
                placeholder="Search by reference number"
              />
              <RecordCount
                onSearchClick={(val) => handleChange("countValue", val)}
                id="pageCount"
                val={filters.countValue}
                filters={isFilterApplied}
                _filters={_isFilterApplied}
              />
              <ExtractReport
                downloadFunction={handleExtractReport}
                styles="extract-report ml-2"
                text="Extract report"
              />
              <Tooltip title="Clear Filter" placement="bottom">
                <FaFilterIcon
                  className="filter-icon"
                  role="button"
                  onClick={clearFilter}
                />
              </Tooltip>
            </div>

            <div className="d-flex justify-content-between mt-3 me-2">
              <span>
                Total Records: <b>{total}</b>
              </span>
            </div>

            <div className="tableContainer">
              <table className="auctionTable">
                <thead className="tableHead">
                  <tr className="table-row">
                    <th>ID</th>
                    <th>User/Subsidiary Name</th>
                    <th>
                      Amount <br />
                      Platform Handling fee{" "}
                    </th>
                    <th>
                      Stripe Fee <br />
                      Tax{" "}
                    </th>
                    <th>
                      <span className="sortColumn">
                        Refund requested on
                        <Sorting
                          sortType="refund_requested_on"
                          sort={sort}
                          handleSort={handleSort}
                        />
                      </span>
                      <br />
                      <span className="sortColumn">
                        Refund approved on
                        <Sorting
                          sortType="refund_approved_on"
                          sort={sort}
                          handleSort={handleSort}
                        />
                      </span>
                      <br />
                      <span className="sortColumn">
                        Refund sent on
                        <Sorting
                          sortType="refund_sent_on"
                          sort={sort}
                          handleSort={handleSort}
                        />
                      </span>
                    </th>
                    <th>Refund Amount</th>
                    <th>Refund Error</th>
                    <th>Transfer reference</th>
                    <th>Action By</th>
                    <th>Status</th>
                    <th>Deposit at</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {isLoading ? (
                  <div className="d-flex justify-content-center three-dot">
                    <ThreeDots
                      height="150"
                      width="150"
                      radius="9"
                      color="#637df4"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  </div>
                ) : (
                  <tbody>
                    {depositsHistory.length > 0 ? (
                      depositsHistory.map((deposit, idx) => {
                        return (
                          <tr className="table-row" key={idx}>
                            <td>{deposit.id}</td>
                            <td className="userName">
                              <a
                                href={`${deposit.source === "subsidiary"
                                  ? "/company-details"
                                  : "/detail-member"
                                  }/${deposit.user_id}`}
                                className="link"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <b>
                                  {deposit.user_name}
                                  {showUserTypeBadge(deposit.source)}
                                </b>
                              </a>
                            </td>

                            <td>
                              {formatCurrency(deposit.amount ?? 0)}
                              <br />
                              {formatCurrency(
                                deposit.platform_handling_fee ?? 0
                              )}
                            </td>
                            <td>
                              {formatCurrency(deposit.stripe_fee ?? 0)}
                              <br />
                              {formatCurrency(deposit.tax ?? 0)}
                            </td>
                            <td>
                              {deposit.refund_requested_on
                                ? moment(deposit.refund_requested_on)
                                  .tz("Europe/Amsterdam")
                                  .format("DD-MM-YYYY HH:mm")
                                : "-"}
                              <br />
                              {deposit.refund_approved_on
                                ? moment(deposit.refund_approved_on)
                                  .tz("Europe/Amsterdam")
                                  .format("DD-MM-YYYY HH:mm")
                                : "-"}
                              <br />
                              {deposit.refund_sent_on
                                ? moment(deposit.refund_sent_on)
                                  .tz("Europe/Amsterdam")
                                  .format("DD-MM-YYYY HH:mm")
                                : "-"}
                            </td>
                            <td>
                              {formatCurrency(deposit.refunded_amount ?? 0)}
                            </td>
                            <td>{deposit.refund_error ?? "-"}</td>
                            <td>{deposit.transfer_reference ?? "-"}</td>
                            <td>{deposit.action_user_name ?? "-"}</td>
                            <td>
                              {DEPOSITHISTORYSTATUS[deposit.status] ?? "-"}
                            </td>
                            <td>
                              {moment(deposit.created_at)
                                .tz("Europe/Amsterdam")
                                .format("DD-MM-YYYY HH:mm")}
                            </td>
                            <td>
                              {showActionButton(deposit.status, deposit.id)}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <NoRecord />
                    )}
                  </tbody>
                )}
              </table>
            </div>
            <div>
              {totalPage > 1 ? (
                <Pagination
                  totalPages={totalPage}
                  page={page}
                  key={totalPage}
                  onPageClick={(page) => setPage(page + 1)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default AuctionDepositHistory;
